export class GetStatistics {
  constructor() {}
  static readonly type = 'GetStatistics';
}
